var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top'),_c('navMenu'),_c('div',{staticClass:"inner clearfix"},[_c('div',{staticClass:"indexworkleft fl"},[_c('taskleft')],1),_c('div',{staticClass:"indexworkright fr"},[_c('taskright')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }